// constants.ts

// LLM styling constants (matching the pattern from MultiDocumentUpload)
export const LLMBGColor = {
  "& .MuiInputBase-root": {
    backgroundColor: "rgba(201,186,232,0.5)",
  },
  "& .MuiInputBase-input": {
    backgroundColor: "transparent",
  },
};

export const LLMBGColor__Select = {
  "& .MuiInputBase-root": {
    backgroundColor: "rgba(201,186,232,0.5)",
  },
  "& .MuiSelect-select": {
    backgroundColor: "rgba(201,186,232,0.5)",
  },
};

export const LLMBGColor__Checkbox = {
  "& .MuiFormControlLabel-root": {
    backgroundColor: "rgba(201,186,232,0.5)",
    borderRadius: "4px",
    paddingRight: "8px",
  },
};

export const STATUS_OPTIONS = [
  { id: "Open", name: "Open" },
  { id: "Closed", name: "Closed" },
];

export const CASH_AVAILABLE_DAYS_OPTIONS = [10, 15, 20, 30, 45, 60].map(d => ({
  id: d,
  name: `After ${d} Days`,
}));
